import store from "utils/store.js";

export default function setApartments(apartments) {
  store.dispatch({
    type: "apartments/set",
    payload: apartments,
  });
}
